import {ErrorModel} from '../../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../../root';
import {ressourcesDto} from './defaultResponseModel/ressources';
const FUNCTION_CODE = 'GET_RESSOURCES';

export async function getRessources(userToken: string, params: string) {
    try {
        const response = await axios.get(
            `${URL}/dashboards/codev/resources/${params}`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );

        return ressourcesDto.from(response.data);
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
